import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]

  toggle() {
    const isShown = this.contentTarget.classList.contains("show")

    if (isShown) {
      this.contentTarget.classList.remove("show")
      this.triggerTarget.classList.add("collapsed")
      this.triggerTarget.setAttribute("aria-expanded", "false")
    } else {
      this.contentTarget.classList.add("show")
      this.triggerTarget.classList.remove("collapsed")
      this.triggerTarget.setAttribute("aria-expanded", "true")
    }
  }
}
